(function () {
  function initSection(section) {
    const carousel = section.querySelector('[data-infinite-carousel]');
    if (!carousel || carousel.dataset.carouselEnabled === 'false') return;

    if (window.TopInfiniteCarousel) {
      window.TopInfiniteCarousel.init(carousel);
    }
  }

  function destroySection(section) {
    const carousel = section.querySelector('[data-infinite-carousel]');
    if (carousel && window.TopInfiniteCarousel) {
      window.TopInfiniteCarousel.destroy(carousel);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="logo-list"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="logo-list"]');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-section-type="logo-list"]');
    if (section) destroySection(section);
  });
})();
